import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../core/_BLComponent.jsx';
import Slider from 'react-slick';

import StoryCard from '../common/_StoryCard.jsx';

export default class AnniversaryStories extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.state = {
			activeStory: 0,
			stories: [],
			nStories: 0
			
		}

		this.slickSettings = {
			dots: false,
			arrows: false,
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: true,
			afterChange: (index) => this.changeSlide(index)
		}
	}

	componentDidMount()
	{
		this.loadStories()
	}

	render() {
		const stories = this.state.stories.map(story => <StoryCard classes="story-card--in-slider story-card--about-page" showPrompt={true} story={story} key={story.idSubmission}/>);

		return (
			<section>
				<div className="anniversary__stories-pagination">
					<button className={"anniversary__stories-pagination-item anniversary__stories-pagination-item--prev" + (this.state.activeStory == 0 ? ' anniversary__stories-pagination-item--disabled' : '')} onClick={this.state.activeStory != 0 ? () => this.prevSlide() : null}><i className="fas fa-chevron-left" title="Previous slide"/></button>
					<button className={"anniversary__stories-pagination-item anniversary__stories-pagination-item--next" + (this.state.activeStory == this.state.stories.length - 1 ? ' anniversary__stories-pagination-item--disabled' : '')} onClick={this.state.activeStory != this.state.stories.length - 1 ? () => this.nextSlide() : null}><i className="fas fa-chevron-right" title="Next slide"/></button>
				</div>
				<Slider className="anniversary__stories-slider slick-slider--adaptive" ref={slider => this.slider = slider} {...this.slickSettings}>
					{stories}
				</Slider>
			</section>
		);
	}

	prevSlide() {
		const prevSlide = this.state.activeStory - 1;

		this.setState({activeStory: prevSlide});

		this.slider.slickGoTo(prevSlide);
	}

	nextSlide() {
		const nextSlide = this.state.activeStory + 1;

		this.setState({activeStory: nextSlide});

		this.slider.slickGoTo(nextSlide);
	}

	changeSlide(index) {
		this.setState({activeStory: index});
	}

	loadStories()
	{
		blapp.models.fetch(
			"_get_stories"
			, {
				controller: "anni.BLCAnniversary"
				, method: "getStories"
				, params: [null, true, null, null, null]
				, refresh: true
			}
		).then(
			(data) => {
				if (data != null) {
					let nStories = data.nStories;
					let stories = data.stories;
					this.setState({stories: stories, nStories: nStories})
				}
			}
		).catch(
			(err) => {
				console.log(err)
			}
		);
	}
};